<ng-template #templateRef>
    <form #editorForm="ngForm" name="editEmail" (ngSubmit)="send()" id="emailEditor">
        <h2 mat-dialog-title>Verstuur e-mail</h2>
        <mat-dialog-content>
            <mat-tab-group>
                <mat-tab label="Message">
                    <div class="row">
                        <div class="col-6">
                            <mat-form-field>
                              <mat-label>Sender name</mat-label>
                                <input matInput name="SenderName" [(ngModel)]="Original.SenderName">
                            </mat-form-field>
                        </div>
                        <div class="col-6">
                            <mat-form-field>
                              <mat-label>Sender E-mail</mat-label>
                                <input matInput name="SenderMail" [(ngModel)]="Original.SenderEmail">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field>
                              <mat-label>Subject</mat-label>
                                <input matInput name="Subject" [(ngModel)]="Original.Subject" required>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- receivers -->
                    <div class="row" *ngIf="Original.Contacts.length > 0">
                        <div class="col-12">
                            <mat-form-field class="example-chip-list">
                              <mat-label>Receivers</mat-label>
                                <mat-chip-grid #chipList>
                                    <mat-chip-row *ngFor="let contact of Original.Contacts" (removed)="Original.Contacts.splice(Original.Contacts.indexOf(contact), 1)">
                                        {{contact.getFullName()}}
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip-row>
                                    <input [matChipInputFor]="chipList" disabled>
                                </mat-chip-grid>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- attachments -->
                    <div class="col-12">
                        <mat-form-field class="example-chip-list">
                          <mat-label>Attachments</mat-label>
                            <mat-chip-grid #chipList>
                                <mat-chip-row *ngFor="let attachment of Original.Attachments" (removed)="Original.Attachments.splice(Original.Attachments.indexOf(attachment), 1)">
                                    {{attachment.Name}}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip-row>
                                <input [matChipInputFor]="chipList" disabled>
                                <mat-icon matIconSuffix (click)="openAttachmentController()">mode_edit</mat-icon>
                            </mat-chip-grid>
                        </mat-form-field>
                    </div>

                    <!-- variables -->
                    <div class="row" *ngIf="Original.Variables.length > 0">
                        <div class="col-sm-12">
                            <mat-chip-listbox>
                                <mat-chip-option *ngFor="let variable of Original.Variables">{{variable.name}}:
                                    {{variable.value}}
                                </mat-chip-option>
                            </mat-chip-listbox>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <ngx-wig name="Body" [(ngModel)]="Original.Body" placeholder="Message"></ngx-wig>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Receivers">
                    <div class="row">
                        <div class="col-12">
                            <table class="mat-mdc-table">
                                <tr>
                                    <th>Firstname</th>
                                    <th>Email</th>
                                    <th style="text-align: right;">
                                        <button type="button" mat-icon-button [matMenuTriggerFor]="addresses">
                                            <mat-icon>add</mat-icon>
                                        </button>
                                        <mat-menu #addresses="matMenu">
                                            <button mat-menu-item (click)="addContact()">Empty contact</button>
                                            <button mat-menu-item *ngFor="let contact of Original.Relation?.Contacts"
                                                    (click)="addContact(contact)">{{contact.getFullName()}}
                                            </button>
                                        </mat-menu>
                                    </th>
                                </tr>
                                <tr *ngFor="let contact of Original.Contacts"
                                    [ngModelGroup]="contact.randomNumber" #ngGroup="ngModelGroup">
                                    <td>
                                        <mat-form-field>
                                          <mat-label>Full name</mat-label>
                                          <input [(ngModel)]="contact.Fullname" matInput name="Fullname"
                                                 required>
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field>
                                          <mat-label>E-mail</mat-label>
                                            <input matInput name="Email" placeholder="E-mail"
                                                   [(ngModel)]="contact.Email" required email>
                                        </mat-form-field>
                                    </td>
                                    <td style="width: 85px; text-align: right;">
                                        <button type="button" mat-icon-button appConfirmDialog
                                                (confirm)="removeContact(contact)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Documenten">
                    <div class="row">
                        <div class="col-12">
                            <table class="mat-mdc-table">
                                <tr>
                                    <th>Document</th>
                                    <th>Date</th>
                                    <th>Total</th>
                                    <th style="text-align: right;">
                                    </th>
                                </tr>
                                <tr *ngFor="let document of Original.Documents"
                                    [ngModelGroup]="document.randomNumber" #ngGroup="ngModelGroup">
                                    <td>
                                        {{document.Number}}
                                    </td>
                                    <td>
                                        {{document.AmountDCInclVat}}
                                    </td>
                                    <td>
                                        {{document.Date | date:'short'}}
                                    </td>
                                    <td style="width: 85px; text-align: right;">
                                        <button type="button" mat-icon-button appConfirmDialog
                                                (confirm)="Original.Documents.splice(Original.Documents.indexOf(document, 1))">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <app-document-selector name="document" #newDocument></app-document-selector>
                                    </td>
                                    <td>
                                        <button type="button" mat-icon-button [disabled]="!newDocument.value"
                                                (click)="Original.Documents.push(newDocument.value); newDocument.value = null;">

                                            <mat-icon>add</mat-icon>
                                        </button>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button type="button" mat-button mat-raised-button [matMenuTriggerFor]="mailTemplates">Load template
            </button>

            <mat-menu #mailTemplates="matMenu">
                <button type="button" mat-menu-item *ngFor="let mail of Mails" [matMenuTriggerFor]="mailTranslations"
                        [matMenuTriggerData]="{data: mail.MailTranslations}">
                    <span>{{mail.Title}}</span>
                </button>
            </mat-menu>

            <mat-menu #mailTranslations="matMenu">
                <ng-template matMenuContent let-data="data">
                    <button type="button" mat-menu-item *ngFor="let translation of data"
                            (click)="onSelectTranslation(translation)">
                        <span>{{translation.Locale?.getFullLocale()}}</span>
                    </button>
                </ng-template>
            </mat-menu>

            <div class="fill-remaining-space"></div>
            <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
            <app-button [disabled]="!editorForm.form.valid || Original.Contacts.length === 0"
                        [isLoading]="isLoading"
                        title="Send"></app-button>
        </mat-dialog-actions>
    </form>
</ng-template>
